import { render, staticRenderFns } from "./OrdenPagoConsulta.vue?vue&type=template&id=467a99f6&"
import script from "./OrdenPagoConsulta.vue?vue&type=script&lang=js&"
export * from "./OrdenPagoConsulta.vue?vue&type=script&lang=js&"
import style0 from "./OrdenPagoConsulta.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrdenPagoConsulta.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports